const steps = [
  {
    number: '01',
    title: 'Inspection & Assessment',
    description: 'A thorough roof evaluation identifying damage, lifespan, and structural concerns specific to your South Bay home. No guesswork, no pressure.',
    icon: 'ri-search-eye-line',
  },
  {
    number: '02',
    title: 'Clear Recommendations',
    description: 'A detailed project scope covering materials, methods, and timelines. Transparent pricing, no hidden costs, no unnecessary upsells.',
    icon: 'ri-file-list-3-line',
  },
  {
    number: '03',
    title: 'Professional Installation',
    description: 'Skilled crews install with precision — ensuring code compliance, minimal disruption to your property, and craftsmanship built to last.',
    icon: 'ri-hammer-line',
  },
  {
    number: '04',
    title: 'Final Walkthrough',
    description: 'A quality check and walkthrough of the finished work before project close. You approve it. We stand behind it.',
    icon: 'ri-checkbox-circle-line',
  },
];

export default function Process() {
  return (
    <section
      className="relative py-28 overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #050d18 0%, #0a1520 50%, #060f1a 100%)' }}
    >
      {/* Subtle grid texture */}
      <div
        className="absolute inset-0 opacity-[0.025]"
        style={{
          backgroundImage: 'linear-gradient(rgba(212,175,55,1) 1px, transparent 1px), linear-gradient(90deg, rgba(212,175,55,1) 1px, transparent 1px)',
          backgroundSize: '64px 64px',
        }}
      ></div>

      {/* Gold accent lines */}
      <div className="absolute top-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(to right, transparent, rgba(212,175,55,0.35) 30%, rgba(212,175,55,0.35) 70%, transparent)' }}></div>
      <div className="absolute bottom-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(to right, transparent, rgba(212,175,55,0.35) 30%, rgba(212,175,55,0.35) 70%, transparent)' }}></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-20">
          <span
            className="text-[#d4af37] text-[10px] uppercase tracking-[4px] font-bold block mb-5"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Our Process
          </span>
          <h2
            className="font-black text-white leading-tight"
            style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 'clamp(2rem, 4vw, 3.2rem)', letterSpacing: '-0.02em' }}
          >
            How We Plan &amp; Deliver
            <br />
            <span className="text-[#d4af37]">Every Project</span>
          </h2>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {/* Connector line desktop */}
          <div
            className="hidden lg:block absolute h-px"
            style={{
              top: '38px',
              left: 'calc(12.5% + 38px)',
              right: 'calc(12.5% + 38px)',
              background: 'linear-gradient(to right, rgba(212,175,55,0.15), rgba(212,175,55,0.5), rgba(212,175,55,0.15))',
            }}
          ></div>

          {steps.map((step, idx) => (
            <div key={idx} className="flex flex-col items-center text-center group">
              {/* Number circle */}
              <div className="relative mb-8 z-10">
                <div
                  className="w-[76px] h-[76px] rounded-full flex items-center justify-center relative z-10 transition-all duration-300 group-hover:border-[#d4af37]/80"
                  style={{ border: '1px solid rgba(212,175,55,0.4)', background: '#0a1520' }}
                >
                  <span
                    className="text-[#d4af37] text-2xl font-black"
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                  >
                    {step.number}
                  </span>
                </div>
                {/* Glow ring */}
                <div
                  className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  style={{ background: 'rgba(212,175,55,0.06)', transform: 'scale(1.35)' }}
                ></div>
              </div>

              {/* Icon */}
              <div className="w-10 h-10 flex items-center justify-center mb-4">
                <i className={`${step.icon} text-[#d4af37]/60 text-2xl group-hover:text-[#d4af37] transition-colors duration-300`}></i>
              </div>

              {/* Title */}
              <h3
                className="text-white font-bold text-[15px] mb-3 leading-snug"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                {step.title}
              </h3>

              {/* Description */}
              <p
                className="text-white/40 text-sm leading-[1.75] max-w-[210px]"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
